export const ENDPOINTS = {
    ADWORDS_ALERT: 'notifications/',
    DIGITAL_MARKETING_APP: 'digital_marketing/',
    PHONES_LOCATION: '/digital_marketing/phones_location',
};

export const KEYS = {
    GOOGLE_ANALYTICS: '_ga',
};
